import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InventoryComponent } from './components/inventory.component';
import { loadEquipmentModuleAsChild } from './equipments/equipment/equipment.module';
import { loadProviderModuleAsChild } from './providers/provider/provider.module';
import { loadLocationModuleAsChild } from './locations/location/location.module';
import { loadAssetTypeModuleAsChild } from './asset-types/asset-type/asset-type.module';
import { loadAssetStateTypeModuleAsChild } from './asset-state-types/asset-state-type/asset-state-type.module';
import { loadEventTypeModuleAsChild } from './event-types/event-type/event-type.module';
import { loadAssetModuleAsChild } from './assets/asset/asset.module';
import { loadAssetEventModuleAsChild } from './asset-events/asset-event/asset-event.module';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: InventoryComponent,
  },
  { path: 'equipments', loadChildren: loadEquipmentModuleAsChild },
  { path: 'providers', loadChildren: loadProviderModuleAsChild },
  { path: 'locations', loadChildren: loadLocationModuleAsChild },
  { path: 'asset-types', loadChildren: loadAssetTypeModuleAsChild },
  { path: 'asset-state-types', loadChildren: loadAssetStateTypeModuleAsChild },
  { path: 'event-types', loadChildren: loadEventTypeModuleAsChild },
  { path: 'assets', loadChildren: loadAssetModuleAsChild },
  { path: 'asset-events', loadChildren: loadAssetEventModuleAsChild },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InventoryRoutingModule {}
